import { useEffect } from 'react'
import { LoginModalProvider } from '../contexts/LoginModalContext'
import Navbar from '../components/Navbar'
import { trackEvent } from '../utils/mixpanel'
import { HeroSection } from '@/components/home/HeroSection'
import { OfferingsSection } from '@/components/home/OfferingsSection'
import { WhatIsWellnessLoopSection } from '@/components/home/WhatIsWellnessLoopSection'
import { ExploreByNeedSection } from '@/components/home/ExploreByNeedSection'
import { HowWeThinkSection } from '@/components/home/HowWeThinkSection'
import { CommunitySection } from '@/components/home/CommunitySection'
import { ForFacilitatorsSection } from '@/components/home/ForFacilitatorsSection'
import { ForOrganizationsSection } from '@/components/home/ForOrganizationsSection'
import { FinalCtaSection } from '@/components/home/FinalCtaSection'
import { SiteFooter } from '@/components/home/SiteFooter'

const HomeV2 = () => {
  useEffect(() => {
    trackEvent('Page Viewed', { page: 'HomeV2' })
  }, [])

  return (
    <LoginModalProvider>
      <div className="flex min-h-screen flex-col bg-cream font-sans">
        {/* <Navbar /> */}
        <main className="flex-grow">
          <HeroSection />
          <OfferingsSection />
          <WhatIsWellnessLoopSection />
          <ExploreByNeedSection />
          <HowWeThinkSection />
          <CommunitySection />
          <ForFacilitatorsSection />
          <ForOrganizationsSection />
          <FinalCtaSection />
        </main>
        <SiteFooter />
      </div>
    </LoginModalProvider>
  )
}

export default HomeV2
